const withOptions = MainComponent => {
  return (props) => {
    const { input: { value }, options } = props
    const content = options.find(option => option.value === value).label
    return (<MainComponent content={content} />)
  }
}

export default withOptions
